import { css, keyframes } from '@styles/theme'

const shimmer = keyframes({
	'0%': { backgroundPosition: '-200% 0' },
	'100%': { backgroundPosition: '200% 0' },
})

export const SkeletonStyles = {
	base: css({
		backgroundColor: '$neutral30',
		backgroundImage:
			'linear-gradient(90deg, $neutral30 0%, $neutral50 50%, $neutral30 100%)',
		backgroundSize: '200% 100%',
		animation: `${shimmer} 1.5s infinite linear`,
	}),
	rounded: css({
		borderRadius: '9999px',
		backgroundColor: '$neutral30',
		backgroundImage:
			'linear-gradient(90deg, $neutral30 0%, $neutral50 50%, $neutral30 100%)',
		backgroundSize: '200% 100%',
		animation: `${shimmer} 1.5s infinite linear`,
	}),
	small: css({
		height: '12px',
		backgroundColor: '$neutral30',
		backgroundImage:
			'linear-gradient(90deg, $neutral30 0%, $neutral50 50%, $neutral30 100%)',
		backgroundSize: '200% 100%',
		animation: `${shimmer} 1.5s infinite linear`,
	}),
	large: css({
		height: '24px',
		backgroundColor: '$neutral30',
		backgroundImage:
			'linear-gradient(90deg, $neutral30 0%, $neutral50 50%, $neutral30 100%)',
		backgroundSize: '200% 100%',
		animation: `${shimmer} 1.5s infinite linear`,
	}),
}
